module.exports = __webpack_public_path__ + "assets/img/thumb-Striver-Careers-Landing-Page.315efea3.webp";